import { render, staticRenderFns } from "./GeneralIcon.vue?vue&type=template&id=050523fa"
import script from "./GeneralIcon.vue?vue&type=script&lang=js"
export * from "./GeneralIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports